/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserNotificationParameterResponse
 */
export interface RevisdomAPIViewModelsUserNotificationParameterResponse {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserNotificationParameterResponse
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserNotificationParameterResponse
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserNotificationParameterResponse
     */
    target?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserNotificationParameterResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserNotificationParameterResponse(value: object): value is RevisdomAPIViewModelsUserNotificationParameterResponse {
    return true;
}

export function RevisdomAPIViewModelsUserNotificationParameterResponseFromJSON(json: any): RevisdomAPIViewModelsUserNotificationParameterResponse {
    return RevisdomAPIViewModelsUserNotificationParameterResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserNotificationParameterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserNotificationParameterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'value': json['value'] == null ? undefined : json['value'],
        'target': json['target'] == null ? undefined : json['target'],
    };
}

export function RevisdomAPIViewModelsUserNotificationParameterResponseToJSON(json: any): RevisdomAPIViewModelsUserNotificationParameterResponse {
    return RevisdomAPIViewModelsUserNotificationParameterResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserNotificationParameterResponseToJSONTyped(value?: RevisdomAPIViewModelsUserNotificationParameterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
        'target': value['target'],
    };
}

